var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-row", { attrs: { center: "", "no-margin": "" } }, [
                _c("div", { staticClass: "breadcrumb" }, [
                  _vm._v(" Roadmap order "),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticClass: "grow" },
        [
          _c(
            "w-col",
            { staticClass: "grow", attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                { staticClass: "grow" },
                [
                  _c(
                    "w-scroll-view",
                    {
                      style: { flexGrow: 1 },
                      attrs: {
                        tag: "w-sortable",
                        "tag-attributes": _vm.sortableAttributes,
                      },
                    },
                    _vm._l(_vm.items, function (item) {
                      return _c(
                        "w-list-item",
                        { key: item.id, attrs: { "show-handle": "" } },
                        [
                          _c("w-list-item-text", { staticClass: "id-field" }, [
                            _vm._v(" " + _vm._s(item.id) + " "),
                          ]),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(item.title) + " "),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-button", { attrs: { to: "/roadmap" } }, [
                        _vm._v(" Cancel "),
                      ]),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }